"use strict";
/*
 * Created on 28. 1. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../core/utils");

var ExportedPriceListRow_1 = require("../model/ExportedPriceListRow");

var ExportedPriceListRowConverter_1 = require("./ExportedPriceListRowConverter");
/**
 * Implementation of {@link ExportedPriceListRowConverter}.
 * @author Radek Beran
 */


var ExportedPriceListRowConverterImpl =
/*#__PURE__*/
function (_ExportedPriceListRow) {
  _inherits(ExportedPriceListRowConverterImpl, _ExportedPriceListRow);

  function ExportedPriceListRowConverterImpl() {
    _classCallCheck(this, ExportedPriceListRowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ExportedPriceListRowConverterImpl).apply(this, arguments));
  }

  _createClass(ExportedPriceListRowConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ExportedPriceListRow_1.ExportedPriceListRow(ExportedPriceListRow_1.ExportedPriceListRow.schema.id.valueOf(conversions.documentToClassId(source)), ExportedPriceListRow_1.ExportedPriceListRow.schema.changeType.valueOfField(source), !utils_1.Utils.isValueMissing(source.changeReason) ? ExportedPriceListRow_1.ExportedPriceListRow.schema.changeReason.valueOfField(source) : null, ExportedPriceListRow_1.ExportedPriceListRow.schema.priceListExternalId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.priceListInternalId.valueOf(conversions.toClassReferenceId(source.priceListInternalId)), !utils_1.Utils.isValueMissing(source.priceListPriority) ? ExportedPriceListRow_1.ExportedPriceListRow.schema.priceListPriority.valueOfField(source) : 0
      /* Temporary default for backward compatibility, can be removed in production. */
      , ExportedPriceListRow_1.ExportedPriceListRow.schema.dateFrom.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.dateTo.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.productExternalId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.productInternalId.valueOf(conversions.toClassReferenceId(source.productInternalId)), !utils_1.Utils.isValueMissing(source.productName) ? ExportedPriceListRow_1.ExportedPriceListRow.schema.productName.valueOfField(source) : ''
      /* Temporary default for backward compatibility, can be removed in production. */
      , ExportedPriceListRow_1.ExportedPriceListRow.schema.salesVariantId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.price.valueOf(conversions.toBigNumber(source.price)), ExportedPriceListRow_1.ExportedPriceListRow.schema.vatTypeId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.externalPriceCode.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.sequenceId.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), ExportedPriceListRow_1.ExportedPriceListRow.schema.exportedReleaseId.valueOf(conversions.toClassReferenceId(source.exportedReleaseId)), ExportedPriceListRow_1.ExportedPriceListRow.schema.releaseItemId.valueOf(conversions.toClassReferenceId(source.releaseItemId)), !utils_1.Utils.isValueMissing(source.priceZoneId) ? ExportedPriceListRow_1.ExportedPriceListRow.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)) : null, !utils_1.Utils.isValueMissing(source.siteId) ? ExportedPriceListRow_1.ExportedPriceListRow.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)) : null, !utils_1.Utils.isValueMissing(source.siteName) ? ExportedPriceListRow_1.ExportedPriceListRow.schema.siteName.valueOf(source.siteName) : null, ExportedPriceListRow_1.ExportedPriceListRow.schema.state.valueOfField(source), ExportedPriceListRow_1.ExportedPriceListRow.schema.exported.valueOfField(source), !utils_1.Utils.isValueMissing(source.accepted) ? ExportedPriceListRow_1.ExportedPriceListRow.schema.accepted.valueOfField(source) : null, !utils_1.Utils.isValueMissing(source.oldPrice) ? this.toObject(source.oldPrice, conversions) : null, !utils_1.Utils.isValueMissing(source.newPrice) ? this.toObject(source.newPrice, conversions) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        changeType: source.changeType,
        changeReason: source.changeReason,
        priceListExternalId: source.priceListExternalId,
        priceListInternalId: conversions.toDocumentReferenceId(source.priceListInternalId),
        priceListPriority: source.priceListPriority,
        dateFrom: conversions.fromDate(source.dateFrom),
        dateTo: conversions.fromDate(source.dateTo),
        productExternalId: source.productExternalId,
        productInternalId: conversions.toDocumentReferenceId(source.productInternalId),
        productName: source.productName,
        salesVariantId: source.salesVariantId,
        price: conversions.fromBigNumber(source.price),
        vatTypeId: source.vatTypeId,
        externalPriceCode: source.externalPriceCode,
        sequenceId: source.sequenceId,
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        exportedReleaseId: conversions.toDocumentReferenceId(source.exportedReleaseId),
        releaseItemId: conversions.toDocumentReferenceId(source.releaseItemId),
        priceZoneId: source.priceZoneId !== null ? conversions.toDocumentReferenceId(source.priceZoneId) : null,
        siteId: source.siteId !== null ? conversions.toDocumentReferenceId(source.siteId) : null,
        siteName: source.siteName,
        state: source.state,
        exported: conversions.fromDate(source.exported),
        accepted: source.accepted !== null ? conversions.fromDate(source.accepted) : null,
        oldPrice: source.oldPrice !== null ? this.toDocument(source.oldPrice, conversions) : null,
        newPrice: source.newPrice !== null ? this.toDocument(source.newPrice, conversions) : null
      });
      return result;
    }
  }]);

  return ExportedPriceListRowConverterImpl;
}(ExportedPriceListRowConverter_1.ExportedPriceListRowConverter);

exports.ExportedPriceListRowConverterImpl = ExportedPriceListRowConverterImpl;